module.exports = __webpack_public_path__ + "assets/images/9caea62778bc8e1c3840106502aac459.jpg";